import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import colorSharp from "../assets/img/color-sharp.png"
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import './ProgressCircle.css'
import { useEffect, useState } from "react";
import FingerprintJS from "@fingerprintjs/fingerprintjs";

export const Statistics = () => {
  const [instagramButtonValue, setInstagramButtonValue] = useState(0);
  const [xButtonValue, setXButtonValue] = useState(0);
  const [linkedInButtonValue, setLinkedInButtonValue] = useState(0);
  const [flappyBirdButtonValue, setFlappyBirdButtonValue] = useState(0);
  const [tetrisButtonValue, setTetrisButtonValue] = useState(0);
  const [mineSweeperButtonValue, setMineSweeperButtonValue] = useState(0);
  const [snakeButtonValue, setSnakeButtonValue] = useState(0);
  const [pinballButtonValue, setPinballButtonValue] = useState(0);
  const [blackjackButtonValue, setBlackjackButtonValue] = useState(0);
  const [battleshipButtonValue, setBattleshipButtonValue] = useState(0);
  const [tweedleButtonValue, setTweedleButtonValue] = useState(0);

  useEffect(() => {
    (async () => {
      const fp = await FingerprintJS.load();
      const result = await fp.get();
      const id = result.visitorId;
      localStorage.setItem("visitorId", result.visitorId);

      // Register visitor & fetch stats
      fetch("/api/statistics", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ visitorId: id }),
      })
        .then(res => res.json())
        .then(data => {

          data.features.forEach(f => {
            switch (f.feature) {
              case "instagram": setInstagramButtonValue(Math.round(f.percentage)); break;
              case "x": setXButtonValue(Math.round(f.percentage)); break;
              case "linkedin": setLinkedInButtonValue(Math.round(f.percentage)); break;
              case "flappybird": setFlappyBirdButtonValue(Math.round(f.percentage)); break;
              case "tetris": setTetrisButtonValue(Math.round(f.percentage)); break;
              case "minesweeper": setMineSweeperButtonValue(Math.round(f.percentage)); break;
              case "snake": setSnakeButtonValue(Math.round(f.percentage)); break;
              case "pinball": setPinballButtonValue(Math.round(f.percentage)); break;
              case "blackjack": setBlackjackButtonValue(Math.round(f.percentage)); break;
              case "tweedle": setTweedleButtonValue(Math.round(f.percentage)); break;
              case "battleship": setBattleshipButtonValue(Math.round(f.percentage)); break;
              default: break;
            }
          });
        });
    })();
  }, []);


  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="statistic" id="statistics">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="statistic-bx wow zoomIn">
                        <h2>Statistics</h2>
                        <p>The following are statistics tracked on this website implemented using fingerprinting.<br></br> The numbers signify an approximate percentage of users that have interacted with specific features.</p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme statistic-slider">
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={instagramButtonValue} 
                                  text={instagramButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Instagram Button</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={xButtonValue} 
                                  text={xButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>X Button</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={linkedInButtonValue} 
                                  text={linkedInButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>LinkedIn Button</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={flappyBirdButtonValue} 
                                  text={flappyBirdButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Flappy Bird</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={tetrisButtonValue} 
                                  text={tetrisButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Tetris</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={mineSweeperButtonValue} 
                                  text={mineSweeperButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Mine Sweeper</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={snakeButtonValue} 
                                  text={snakeButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Snake</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={pinballButtonValue} 
                                  text={pinballButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Pinball</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={blackjackButtonValue} 
                                  text={blackjackButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Blackjack</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={battleshipButtonValue} 
                                  text={battleshipButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Battleship</h5>
                            </div>
                            <div className="item">
                              <div className="progress-wrapper">
                                <CircularProgressbar 
                                  value={tweedleButtonValue} 
                                  text={tweedleButtonValue+`%`} 
                                  styles={buildStyles({
                                    pathColor: "url(#pinkPurpleGradient)",
                                    textColor: "#ffffffff",
                                    trailColor: "#000000ff",
                                  })}
                                />
                              </div>
                                <h5>Tweedle</h5>
                            </div>
                        </Carousel>
                        <svg style={{ height: 0 }}>
                          <defs>
                            <linearGradient id="pinkPurpleGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                              <stop offset="0%" stopColor="#ff6ec7" />
                              <stop offset="100%" stopColor="#8e2de2" />
                            </linearGradient>
                          </defs>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="" />
    </section>
  )
}